export class TextSerializableValue {
  value?: string;

  constructor(value?: string) {
    this.value = value;
  }
}
